function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEducationBooks({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "education_x5F_books",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 32 32",
    style: {
      enableBackground: "new 0 0 32 32"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FD5C3F"
    },
    d: "M10,32H0V0h10V32z M2,30h6V2H2V30z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FD5C3F"
    },
    d: "M18,32H8V2h10V32z M10,30h6V4h-6V30z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 5,
    style: {
      fill: "#FD5C3F"
    },
    width: 8,
    height: 2
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 25,
    style: {
      fill: "#FD5C3F"
    },
    width: 8,
    height: 2
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 9,
    y: 23,
    style: {
      fill: "#FD5C3F"
    },
    width: 8,
    height: 2
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 9,
    y: 8,
    style: {
      fill: "#FD5C3F"
    },
    width: 8,
    height: 2
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 12,
    y: 12,
    style: {
      fill: "#FD5C3F"
    },
    width: 2,
    height: 9
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 13,
    style: {
      fill: "#FD5C3F"
    },
    width: 2,
    height: 10
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 9,
    style: {
      fill: "#FD5C3F"
    },
    width: 2,
    height: 2
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FD5C3F"
    },
    d: "M24,32h-8V0h8V32z M18,30h4V2h-4V30z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FD5C3F"
    },
    d: "M32,32H22V2h10V32z M24,30h6V4h-6V30z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 23,
    y: 25,
    style: {
      fill: "#FD5C3F"
    },
    width: 8,
    height: 2
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 23,
    y: 6,
    style: {
      fill: "#FD5C3F"
    },
    width: 8,
    height: 2
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 26,
    y: 11,
    style: {
      fill: "#FD5C3F"
    },
    width: 2,
    height: 12
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEducationBooks);
export default __webpack_public_path__ + "static/media/education_books.836fddf30d69ab4fac970ad4424eba38.svg";
export { ForwardRef as ReactComponent };